import { makeStyles } from '@material-ui/core';
import { COLOR_TONE } from '../../../shared/styles/colors';

export default makeStyles(() => ({
  root: {
    border: `1px solid ${COLOR_TONE.gray[10]}`,
    padding: '1rem 0.625rem',
  },
  title: {
    marginBottom: '1rem',
    fontSize: '0.625rem',
    color: COLOR_TONE.gray[30],
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '1rem',
    letterSpacing: '1.2px',
  },
  checkCodeText: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: COLOR_TONE.gray[50],
  },
  checkCode: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: '1.25rem',
    color: COLOR_TONE.gray[50],
    borderRadius: '62.4375rem',
    backgroundColor: COLOR_TONE.gray[10],
    padding: '0.25rem 0.5rem',
  },
  bagsQuantityText: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: COLOR_TONE.gray[50],
  },
  quantityButton: {
    borderRadius: '50%',
    backgroundColor: COLOR_TONE.teal[50],
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: COLOR_TONE.gray['A10'],
    width: '1.5rem',
    height: '1.5rem',
    cursor: 'pointer',
  },
  quantityButtonDisabled: {
    borderRadius: '50%',
    backgroundColor: COLOR_TONE.gray[10],
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: COLOR_TONE.gray['A10'],
    width: '1.5rem',
    height: '1.5rem',
    cursor: 'not-allowed',
  },
  quantityText: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: COLOR_TONE.gray[50],
  },
  drinksText: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: COLOR_TONE.gray[50],
  },
  radioGroupOptions: {
    display: 'flex',
    flexDirection: 'row',
  },
  radioRootButton: {
    margin: '0',
    flexDirection: 'row-reverse',
    '& .MuiRadio-root': {
      padding: 0,
      marginLeft: '0.25rem',
    },
  },
  radioLabelButton: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: COLOR_TONE.gray[50],
  },
  loading: {
    color: COLOR_TONE.gray[30],
    fontSize: '0.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.031235rem',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  success: {
    color: COLOR_TONE.teal[50],
    fontSize: '0.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.031235rem',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  successIcon: {
    color: COLOR_TONE.teal[50],
    fontSize: '0.75rem',
    fontWeight: 'bold',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  error: {
    color: COLOR_TONE.red[50],
    fontSize: '0.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.031235rem',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  errorIcon: {
    color: COLOR_TONE.red[40],
    fontSize: '0.75rem',
    fontWeight: 'bold',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  retry: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
}));
